import * as constants from "./constants";

export const fetchAllStockManagementRegisters = (filters) => ({
  type: constants.FETCH_ALL_STOCK_MANAGEMENT_REGISTERS,
  data: filters,
});

export const fetchAllStockManagementRegistersSuccess = (data) => ({
  type: constants.FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_SUCCESS,
  data,
});

export const fetchAllStockManagementRegistersError = (error) => ({
  type: constants.FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_ERROR,
  error,
});

export const fetchStockManagementRegister = (id) => ({
  type: constants.FETCH_STOCK_MANAGEMENT_REGISTER,
  data: id,
});

export const fetchStockManagementRegisterSuccess = (data) => ({
  type: constants.FETCH_STOCK_MANAGEMENT_REGISTER_SUCCESS,
  data,
});

export const fetchStockManagementRegisterError = (error) => ({
  type: constants.FETCH_STOCK_MANAGEMENT_REGISTER_ERROR,
  error,
});

export const createStockManagementRegister = (data) => ({
  type: constants.CREATE_STOCK_MANAGEMENT_REGISTER,
  data,
});

export const createStockManagementRegisterSuccess = (data) => ({
  type: constants.CREATE_STOCK_MANAGEMENT_REGISTER_SUCCESS,
  data,
});

export const createStockManagementRegisterError = (error) => ({
  type: constants.CREATE_STOCK_MANAGEMENT_REGISTER_ERROR,
  error,
});

export const updateStockManagementRegister = (id, data) => ({
  type: constants.UPDATE_STOCK_MANAGEMENT_REGISTER,
  data: { id, ...data },
});

export const updateStockManagementRegisterSuccess = (data) => ({
  type: constants.UPDATE_STOCK_MANAGEMENT_REGISTER_SUCCESS,
  data,
});

export const updateStockManagementRegisterError = (error) => ({
  type: constants.UPDATE_STOCK_MANAGEMENT_REGISTER_ERROR,
  error,
});

export const fetchAllStockTakes = (registerId, filters) => ({
  type: constants.FETCH_ALL_STOCK_TAKES,
  data: { registerId, ...filters },
});

export const fetchAllStockTakesSuccess = (registerId, data) => ({
  type: constants.FETCH_ALL_STOCK_TAKES_SUCCESS,
  data: { registerId, data },
});

export const fetchAllStockTakesError = (registerId, error) => ({
  type: constants.FETCH_ALL_STOCK_TAKES_ERROR,
  data: { registerId, error },
});

export const createStockTake = (registerId, data) => ({
  type: constants.CREATE_STOCK_TAKE,
  data: { registerId, ...data },
});

export const createStockTakeSuccess = (registerId, data) => ({
  type: constants.CREATE_STOCK_TAKE_SUCCESS,
  data: { registerId, data },
});

export const createStockTakeError = (registerId, error) => ({
  type: constants.CREATE_STOCK_TAKE_ERROR,
  data: { registerId, error },
});

export const updateStockTake = (registerId, stockTakeId, data) => ({
  type: constants.UPDATE_STOCK_TAKE,
  data: { registerId, stockTakeId, ...data },
});

export const updateStockTakeSuccess = (registerId, data) => ({
  type: constants.UPDATE_STOCK_TAKE_SUCCESS,
  data: { registerId, data },
});

export const updateStockTakeError = (registerId, error) => ({
  type: constants.UPDATE_STOCK_TAKE_ERROR,
  data: { registerId, error },
});

export const deleteStockTake = (registerId, stockTakeId) => ({
  type: constants.DELETE_STOCK_TAKE,
  data: { registerId, stockTakeId },
});

export const deleteStockTakeSuccess = (stockTakeId) => ({
  type: constants.DELETE_STOCK_TAKE_SUCCESS,
  data: stockTakeId,
});

export const deleteStockTakeError = (error) => ({
  type: constants.DELETE_STOCK_TAKE_ERROR,
  error,
});

export const deleteStockManagementRegister = (id) => ({
  type: constants.DELETE_STOCK_MANAGEMENT_REGISTER,
  data: id,
});

export const deleteStockManagementRegisterSuccess = (id) => ({
  type: constants.DELETE_STOCK_MANAGEMENT_REGISTER_SUCCESS,
  data: id,
});

export const deleteStockManagementRegisterError = (error) => ({
  type: constants.DELETE_STOCK_MANAGEMENT_REGISTER_ERROR,
  error,
});

export const setStockManagementFilters = (filters) => ({
  type: constants.SET_STOCK_MANAGEMENT_FILTERS,
  data: filters,
});

export const setStockManagementPagination = (pagination) => ({
  type: constants.SET_STOCK_MANAGEMENT_PAGINATION,
  data: pagination,
});

export const clearStockManagementRegister = () => ({
  type: constants.CLEAR_STOCK_MANAGEMENT_REGISTER,
});

export const clearStockTakes = (registerId) => ({
  type: constants.CLEAR_STOCK_TAKES,
  data: registerId,
});

export const fetchOmniCurrentStock = (params) => ({
  type: constants.FETCH_OMNI_CURRENT_STOCK,
  data: params,
});

export const fetchOmniCurrentStockSuccess = (data) => ({
  type: constants.FETCH_OMNI_CURRENT_STOCK_SUCCESS,
  data,
});

export const fetchOmniCurrentStockError = (error, request = null) => ({
  type: constants.FETCH_OMNI_CURRENT_STOCK_ERROR,
  error,
  request,
});

// Cached per-register snapshot data returned by the bulk warehouse snapshot API.
export const fetchOmniSnapshotsSuccess = (data) => ({
  type: constants.FETCH_OMNI_SNAPSHOTS_SUCCESS,
  data,
});


export const clearStockTakeError = (registerId) => ({
  type: constants.CLEAR_STOCK_TAKE_ERROR,
  data: registerId,
});

export const generateVarianceReport = (registerId) => ({
  type: constants.GENERATE_VARIANCE_REPORT,
  data: { registerId },
});

export const generateVarianceReportSuccess = (registerId, data) => ({
  type: constants.GENERATE_VARIANCE_REPORT_SUCCESS,
  data: { registerId, data },
});

export const generateVarianceReportError = (registerId, error) => ({
  type: constants.GENERATE_VARIANCE_REPORT_ERROR,
  data: { registerId, error },
});

export const fetchAllVarianceReports = (registerId, filters) => ({
  type: constants.FETCH_ALL_VARIANCE_REPORTS,
  data: { registerId, ...filters },
});

export const fetchAllVarianceReportsSuccess = (registerId, data) => ({
  type: constants.FETCH_ALL_VARIANCE_REPORTS_SUCCESS,
  data: { registerId, data },
});

export const fetchAllVarianceReportsError = (registerId, error) => ({
  type: constants.FETCH_ALL_VARIANCE_REPORTS_ERROR,
  data: { registerId, error },
});

export const fetchOneVarianceReport = (registerId, id) => ({
  type: constants.FETCH_ONE_VARIANCE_REPORT,
  data: { registerId, id },
});

export const fetchOneVarianceReportSuccess = (data) => ({
  type: constants.FETCH_ONE_VARIANCE_REPORT_SUCCESS,
  data,
});

export const fetchOneVarianceReportError = (error) => ({
  type: constants.FETCH_ONE_VARIANCE_REPORT_ERROR,
  error,
});

export const updateVarianceReport = (registerId, id, data) => ({
  type: constants.UPDATE_VARIANCE_REPORT,
  data: { registerId, id, ...data },
});

export const updateVarianceReportSuccess = (registerId, data) => ({
  type: constants.UPDATE_VARIANCE_REPORT_SUCCESS,
  data: { registerId, data },
});

export const updateVarianceReportError = (error) => ({
  type: constants.UPDATE_VARIANCE_REPORT_ERROR,
  error,
});

export const addVarianceComment = (registerId, id, data) => ({
  type: constants.ADD_VARIANCE_COMMENT,
  data: { registerId, id, ...data },
});

export const addVarianceCommentSuccess = (data) => ({
  type: constants.ADD_VARIANCE_COMMENT_SUCCESS,
  data,
});

export const addVarianceCommentError = (error) => ({
  type: constants.ADD_VARIANCE_COMMENT_ERROR,
  error,
});

export const deleteVarianceAttachment = (registerId, reportId, attachmentId) => ({
  type: constants.DELETE_VARIANCE_ATTACHMENT,
  data: { registerId, reportId, attachmentId },
});

export const deleteVarianceAttachmentSuccess = (attachmentId) => ({
  type: constants.DELETE_VARIANCE_ATTACHMENT_SUCCESS,
  data: attachmentId,
});

export const deleteVarianceAttachmentError = (error) => ({
  type: constants.DELETE_VARIANCE_ATTACHMENT_ERROR,
  error,
});

export const fetchVarianceHistory = (registerId, reportId) => ({
  type: constants.FETCH_VARIANCE_HISTORY,
  data: { registerId, reportId },
});

export const fetchVarianceHistorySuccess = (reportId, data) => ({
  type: constants.FETCH_VARIANCE_HISTORY_SUCCESS,
  data: { reportId, data },
});

export const fetchVarianceHistoryError = (error) => ({
  type: constants.FETCH_VARIANCE_HISTORY_ERROR,
  error,
});

export const syncLabStock = () => ({
  type: constants.SYNC_LAB_STOCK,
});

export const syncLabStockSuccess = (data) => ({
  type: constants.SYNC_LAB_STOCK_SUCCESS,
  data,
});

export const syncLabStockError = (error) => ({
  type: constants.SYNC_LAB_STOCK_ERROR,
  error,
});

export const fetchLastSyncTime = () => ({
  type: constants.FETCH_LAST_SYNC_TIME,
});

export const fetchLastSyncTimeSuccess = (data) => ({
  type: constants.FETCH_LAST_SYNC_TIME_SUCCESS,
  data,
});

export const fetchLastSyncTimeError = (error) => ({
  type: constants.FETCH_LAST_SYNC_TIME_ERROR,
  error,
});